import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalBadges } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14" aria-labelledby="final-cta-heading" data-id="element-64" data-mp="3lw9eanbv0hzt">
      <div className="mx-auto max-w-4xl px-6" data-id="element-65" data-mp="3qrou3ktfgnyv">
        <div className="rounded-4xl bg-navy-deep px-7 py-11 text-center shadow-lift sm:px-12" data-id="element-66" data-mp="3vrkw5eike5bs">
          <p className="eyebrow text-lime" data-id="element-67" data-mp="2y5x04uq0tp0s">The choice is yours</p>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-2xl font-display text-[1.85rem] font-extrabold leading-[1.1] text-shell sm:text-4xl" data-id="element-68" data-mp="333ykdiz6nudu">
            Next Monday you can go back to searching the internet — or walk onto
            the court with The Vault in your pocket.
          </h2>

          <CtaButton size="large" className="mt-9" data-id="element-69" data-mp="2fembkk7rpoc2">
            Join the elite coaches — access the Vault
          </CtaButton>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-70" data-mp="2kcfg78tfaaa8">
            {finalBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-xs text-shell/80" data-id="element-71" data-mp="2dbguld27qonf">
                <CheckIcon className="h-3.5 w-3.5 text-lime" strokeWidth={2.6} aria-hidden="true" data-id="element-72" data-mp="28dfdgxockzel" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}